import { render, staticRenderFns } from "./SubproyectosListView.vue?vue&type=template&id=230a77a5"
import script from "./SubproyectosListView.vue?vue&type=script&lang=js"
export * from "./SubproyectosListView.vue?vue&type=script&lang=js"
import style0 from "./SubproyectosListView.vue?vue&type=style&index=0&id=230a77a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports